import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React, { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import progressMultiStep from '../../styles/progressMultiStep.js';
import { flex } from '../../styles/layout/flex.js';
import { flexJustifyBetween } from '../../styles/layout/flexJustifyBetween.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function MultiStepTracker(_ref) {
  var currentStep = _ref.currentStep,
      currentSubStep = _ref.currentSubStep,
      label = _ref.label,
      theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["currentStep", "currentSubStep", "label", "theme", "children"]);

  var numberChildren = React.Children.count(children);

  var multiStepStyles = _objectSpread(_objectSpread({}, progressMultiStep.multiStep), theme);

  var orderListStyles = _objectSpread(_objectSpread(_objectSpread({}, progressMultiStep.multiStep_ol), flex), flexJustifyBetween);

  var ariaLabel = useMemo(function () {
    return currentStep > 0 && currentStep < numberChildren ? children[currentStep - 1].props['aria-label'] : undefined;
  }, [currentStep, children, numberChildren]);
  return jsx("div", _extends({
    css: multiStepStyles
  }, otherProps), jsx("ol", {
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    role: "progressbar",
    "aria-label": label,
    "aria-valuenow": currentStep,
    "aria-valuemin": 1,
    "aria-valuetext": ariaLabel,
    "aria-valuemax": numberChildren,
    css: orderListStyles
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      current: index === currentStep - 1,
      active: index < currentStep - 1,
      last: index === numberChildren - 1,
      currentSubStep: index === currentStep - 1 ? currentSubStep : undefined
    }));
  })));
}
MultiStepTracker.defaultProps = {
  currentSubStep: undefined,
  label: 'Progress Bar',
  theme: undefined
};

export default MultiStepTracker;
